/* 十页原型（proto-shell 01–10）与 06 的交互对齐（2026-09-25），逻辑照搬 06（snippets/auxito-bulb-size-guide-v2.liquid）：
   1. 面包屑：把文字里的 “ / ” 换成分隔符元素（.apsp-crumb__sep，样式画成主题细箭头 ›）；各页模板已直接输出分隔符元素，这里只兜底。
   2. 手机吸顶车型栏：有选车卡（[data-apsp-vcard]）的页面，选车卡滑出页头下沿后从页头下方滑出，回到选车卡时滑回；
      rAF 节流；主题吸顶页头晚生效（body / 页头 class 变化）时重新对齐。
   3. Change：平滑滚回选车卡（放到屏幕中间，至少让出页头高度），卡片高亮一下，滚动结束后聚焦并弹出 Year。 */
(function () {
  'use strict';
  var root = document.querySelector('.apsp:not(.bsg2)');
  if (!root) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 1. 面包屑分隔符 */
  Array.prototype.forEach.call(root.querySelectorAll('.crumb, .apsp-crumb'), function (crumb) {
    if (crumb.querySelector('.apsp-crumb__sep')) return;
    Array.prototype.slice.call(crumb.childNodes).forEach(function (node) {
      if (node.nodeType !== 3 || node.nodeValue.indexOf('/') < 0) return;
      var parts = node.nodeValue.split('/');
      var frag = document.createDocumentFragment();
      parts.forEach(function (text, i) {
        if (text.trim()) frag.appendChild(document.createTextNode(text.trim()));
        if (i < parts.length - 1) {
          var sep = document.createElement('span');
          sep.className = 'apsp-crumb__sep';
          sep.setAttribute('aria-hidden', 'true');
          frag.appendChild(sep);
        }
      });
      crumb.replaceChild(frag, node);
    });
  });

  /* 05 筛选栏：手机端默认收起（只露出选中项），Show all / Show less 切换；桌面按钮不显示 */
  var filters = root.querySelector('.apsp-plp-filters');
  if (filters && !filters.querySelector('.apsp-plp-filters__toggle')) {
    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'apsp-plp-filters__toggle';
    var setCollapsed = function (on) {
      filters.classList.toggle('is-collapsed', on);
      toggle.textContent = on ? 'Show all' : 'Show less';
      toggle.setAttribute('aria-expanded', on ? 'false' : 'true');
    };
    toggle.addEventListener('click', function () { setCollapsed(!filters.classList.contains('is-collapsed')); });
    filters.insertBefore(toggle, filters.firstChild);
    setCollapsed(true);
  }

  /* 2. 手机吸顶车型栏（有选车卡的页面；运营 2026-09-29：01 的 Banner 选车框、02 的 Find Your Exact Vehicle 卡也用同一条，
        页面有这条栏时隐藏页头自带的黄色选车按钮，见 06-parity.css） */
  var card = root.querySelector('[data-apsp-vcard]') || root.querySelector('.hero-form') || root.querySelector('.apsp-model-year-card');
  if (!card) return;
  var isVcard = card.hasAttribute('data-apsp-vcard');
  var screen = root.getAttribute('data-apsp-screen') || '';
  var header = document.getElementById('shopify-section-static-header');
  var mobile = window.matchMedia('(max-width: 600px)');
  var ctx = window.AuxitoProtoShellVehicle || null;
  var vehicleName = '';
  function savedVehicleName() {
    try {
      var savedCar = (JSON.parse(window.localStorage.getItem('auxito_vehicles') || 'null') || {}).current;
      if (savedCar && savedCar.year && savedCar.make && savedCar.model) {
        var hitCar = ctx ? ctx.match(savedCar.year, savedCar.make, savedCar.model) : null;
        return hitCar ? ctx.fields.name(hitCar) : [savedCar.year, savedCar.make, savedCar.model].join(' ');
      }
    } catch (e) { /* 读不到按没选过车 */ }
    return '';
  }
  if (isVcard) {
    var nameEl = card.querySelector('.apsp-vcard__name');
    // 优先用选车卡上显示的车名：09 / 10 的选车卡按全站车型目录（如 2021 Toyota Tacoma），公共车型上下文只认上线车型，会退回默认车（运营 2026-10-27）
    vehicleName = nameEl && nameEl.textContent.trim() || (ctx && !card.hasAttribute('data-apsp-vcard-fixed') ? ctx.fields.name(ctx.current) : '');
  } else if (screen === '01' || screen === '02') {
    // 01 没有页面车型、02 只定了品牌 + 车型（没有年份）：显示访客已选的车（全站车型，含上线范围外的车），与页头选车按钮一致；
    // 没选过就提示选车。02 不按页面车型拼「最新年份」（运营 2026-10-27：原来显示 2025 … 2500 HD，访客没选过这台车）
    vehicleName = savedVehicleName();
  } else if (ctx) {
    vehicleName = ctx.fields.name(ctx.current);
  }

  var bar = document.createElement('div');
  bar.className = 'apsp-mbar';
  bar.setAttribute('aria-hidden', 'true');
  bar.innerHTML = '<div><small></small><b></b></div><button type="button"></button>';
  function setBarName(name) {
    bar.querySelector('small').textContent = name ? 'Selected vehicle' : 'Your vehicle';
    bar.querySelector('b').textContent = name || 'Select your vehicle';
    bar.querySelector('button').textContent = name ? 'Change' : 'Select';
  }
  setBarName(vehicleName);
  root.insertBefore(bar, root.firstChild);
  // 01 / 02 显示访客保存的车：同页换车（My Garage）、其他标签页改车、浏览器返回（BFCache）后重新读取（Astra 10-27）
  if (!isVcard && (screen === '01' || screen === '02')) {
    var resyncSaved = function () { setBarName(savedVehicleName()); };
    window.addEventListener('auxito:vehicle-context-changed', resyncSaved);
    window.addEventListener('storage', function (e) { if (!e.key || e.key === 'auxito_vehicles') resyncSaved(); });
    window.addEventListener('pageshow', function (e) { if (e.persisted) resyncSaved(); });
  }
  // 选车卡换车后车名会变，吸顶栏跟着改
  var nameNode = isVcard ? card.querySelector('.apsp-vcard__name') : null;
  if (nameNode && window.MutationObserver) {
    new MutationObserver(function () {
      var next = nameNode.textContent.trim();
      if (next) setBarName(next);
    }).observe(nameNode, { childList: true, characterData: true, subtree: true });
  }
  if (header) {
    var z = parseInt(window.getComputedStyle(header).zIndex, 10);
    if (z > 1) bar.style.zIndex = String(z - 1); // 压在页头下面，滑出时像从页头里出来
  }

  function headerBottom() {
    if (!header) return 0;
    var bottom = header.getBoundingClientRect().bottom;
    return bottom > 0 ? bottom : 0;
  }
  var ticking = false;
  var shown = false;
  function syncBar() {
    ticking = false;
    var top = headerBottom();
    var want = mobile.matches && card.getBoundingClientRect().bottom < top + 8;
    bar.style.top = top + 'px';
    if (want !== shown) {
      shown = want;
      bar.classList.toggle('is-shown', want);
      bar.setAttribute('aria-hidden', want ? 'false' : 'true');
    }
  }
  function requestSync() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(syncBar);
  }
  window.addEventListener('scroll', requestSync, { passive: true });
  window.addEventListener('resize', requestSync);
  if (header && window.MutationObserver) {
    var watch = new MutationObserver(requestSync);
    watch.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    watch.observe(header, { attributes: true, attributeFilter: ['class', 'style'] });
  }
  syncBar();

  /* 3. Change：滚回选车卡、高亮、弹出 Year */
  var yearSel = card.querySelector('[data-apsp-vcard-year]') || card.querySelector('select');
  bar.querySelector('button').addEventListener('click', function () {
    var rect = card.getBoundingClientRect();
    var offset = Math.max((window.innerHeight - rect.height) / 2, (header ? header.offsetHeight : 0) + 12);
    var target = Math.max(Math.round(rect.top + window.pageYOffset - offset), 0);
    window.scrollTo({ top: target, behavior: reduceMotion.matches ? 'auto' : 'smooth' });
    var start = Date.now();
    (function waitForArrival() {
      if (Math.abs(window.pageYOffset - target) > 2 && Date.now() - start < 900) return window.requestAnimationFrame(waitForArrival);
      card.classList.add('is-pulse');
      window.setTimeout(function () { card.classList.remove('is-pulse'); }, 700);
      if (!yearSel) return;
      yearSel.focus({ preventScroll: true });
      if (typeof yearSel.showPicker === 'function') {
        try { yearSel.showPicker(); } catch (e) { /* 部分浏览器不允许，保留聚焦即可 */ }
      }
    })();
  });
})();
